import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles, RefreshCw } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Panel } from "@/components/common";
import { Button } from "@/components/ui/button";

export default function AiSummary({ month }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async (refresh = false) => {
    setBusy(true);
    try { const r = await api.get(`/analytics/ai-summary?month=${month}${refresh ? "&refresh=true" : ""}`); setD(r.data); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  useEffect(() => { setD(null); load(); }, [month]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Panel title={d?.title || "Analisa Produksi AI"} testId="ai-summary-panel"
      action={<Button size="sm" variant="outline" disabled={busy} onClick={() => load(true)} data-testid="ai-summary-refresh"><RefreshCw className={`w-3.5 h-3.5 mr-1 ${busy ? "animate-spin" : ""}`} />Perbarui</Button>}>
      {!d && <div className="text-sm text-slate-400 flex items-center gap-2"><Sparkles className="w-4 h-4" />Menyusun analisa dari data database…</div>}
      {d && (
        <>
          <div className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed" data-testid="ai-summary-narrative">{d.narrative}</div>
          <div className="text-[11px] text-slate-400 mt-3">Semua angka berasal dari database (CONFIRMED). Model {d.model} · dibuat {new Date(d.generated_at).toLocaleString("id-ID", { timeZone: "Asia/Makassar" })} WITA</div>
        </>
      )}
    </Panel>
  );
}
